













import { defineComponent, computed } from '@vue/composition-api'
import KisweSelect from '../KisweSelect'
import { useSizes, useThemes } from '@/modules/kisweui/compositions'
import { KisweFont } from '@/modules/kisweui/types/fonts'
// import { FontManager } from 'font-picker'
// => this is the Class used internally by font-picker-vue. The latter only provides a component wrapper which
//    is hard to style to our needs.

export default defineComponent({
  name: 'KisweSelectFont',
  components: {
    KisweSelect
  },
  props: {
    label: {
      type: String,
      required: false,
      default: 'Font'
    },
    value: {
      type: String as () => KisweFont|null,
      required: false,
      default: null,
      validator: (value: KisweFont|null) => value === null || Object.values(KisweFont).includes(value)
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Select a font'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    filterable: {
      type: Boolean,
      required: false,
      default: true
    },
    ...useSizes().props,
    ...useThemes().props
  },
  setup (props, { emit }) {
    const fontOptions = computed(() => Object.values(KisweFont)
      .map((font: KisweFont) => ({ label: font, value: font })))
    const selectedFont = computed({
      get (): KisweFont|null {
        return props.value ?? fontOptions.value[0].value
      },
      set (value: KisweFont|null) {
        emit('input', value)
      }
    })
    return {
      fontOptions,
      selectedFont
    }
  }
})
